import { Icon, MenuItem, Typography, useTheme } from '@web-chat-core/ui-kit';
import { LocalParticipant } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';

interface RaiseHandMenuItemProps {
    participant: LocalParticipant;
}

export const RaiseHandMenuItem = ({ participant }: RaiseHandMenuItemProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { checkIsHandRaised, toggleRaiseHand } = useRaiseHand();
    const isHandRaised = checkIsHandRaised(participant);
    const title = t(isHandRaised ? 'web_call_put_hand' : 'web_call_raise_hand');

    const handleClick = () => {
        toggleRaiseHand(participant);
    };
    return (
        <MenuItem id="raise-hand-menu-item" type="dropdown" onClick={handleClick}>
            <Icon icon="icHandUp" color={theme.root.colors.basicColors['60%']} size={24} />
            <Typography variant="subtitle3">{title}</Typography>
        </MenuItem>
    );
};
